<template>
    <div class="form-group">
        <label class="label required">{{ $t("Pack") }}</label>
        <div class="row col-12 p-0">
            <div class="col-6 p-0">
                <app-input
                    :placeholder="$t('Select pack')"
                    type="search-select"
                    v-model="selectedPack"
                    :list="list"
                    @input="updateValue"
                    :disabled="is_view"
                />
            </div>
            <div class="col-6 p-0">
                <app-input 
                    :placeholder="$t('Quantity')"
                    type="text"
                    v-model="displayValue"
                    @input="updateValue"
                    :disabled="is_view"
                    @blur="rawInput = ''"
                    :required="true"
                />
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'productPack',
    props: {
        value: {
            type: Object,
            default: () => ({
                pack: { id : null, name : null},
                quantity : 0,
            })
        },
        list: {
            type: Array,
            required: true
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            isTypingDot: false,
            rawInput: '',
            internalValue: { ...this.value }
        };
    },
    computed: {
        selectedPack: {
            get() {
                // Leemos de la copia local
                return this.internalValue.pack ? this.internalValue.pack.id : null;
            },
            set(newId) {
                // Buscamos el objeto completo en la lista
                const fullPackObject = this.list.find(item => item.id === newId);
                
                // Actualizamos la copia local
                this.internalValue.pack = fullPackObject ? { ...fullPackObject } : { id: null, name: null };
                
                // Disparamos la actualización al padre
                this.updateValue();
            }
        },
        displayValue: {
            get() {
                const val = this.internalValue.quantity;
                if (val === null || val === '') return this.rawInput || '';
                if (this.rawInput !== '') return this.rawInput;
                return new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInput = cleanValue;
                if (cleanValue.endsWith('.')) {
                    this.isTypingDot = true;
                    return;
                }
                this.isTypingDot = false;
                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);
                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.quantity = numericValue;
                    this.updateValue();
                }
            }
        }
    },
    watch: {
        // Si el padre cambia el objeto desde afuera, actualizamos nuestra copia
        value: {
            handler(newVal) {
                this.internalValue = JSON.parse(JSON.stringify(newVal));
            },
            deep: true
        }
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        },

        onlyNumbers(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                event.preventDefault();
            }
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    /* Quitamos paddings laterales de la fila interna para alinear con el label */
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>